import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { paymentShape } from 'constants/propTypes';
import { colours } from 'themes/default';

const WarningMessage = styled.p`
  color: ${colours.Messaging.WarningOrange};
  padding-top: 10px;
`;

const PaymentAgeWarning = ({ payment, amount, minAmount = 0.01, maxAmount, hasError }) => {
  const numericAmount = Number(amount);
  const isValidAmount = Number.isFinite(numericAmount) && numericAmount >= minAmount && numericAmount <= maxAmount;
  const isOldPayment =
    payment?.transactionTimestamp && moment(payment.transactionTimestamp, moment.ISO_8601, true).isBefore(moment().subtract(365, 'days'));

  if (hasError || !isValidAmount || !isOldPayment) {
    return null;
  }

  return (
    <WarningMessage role="status" data-testid="payment-age-warning" data-cy="payment-age-warning">
      <FormattedMessage id="refunds.warning.paymentAge" />
    </WarningMessage>
  );
};

PaymentAgeWarning.propTypes = {
  payment: paymentShape,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minAmount: PropTypes.number,
  maxAmount: PropTypes.number.isRequired,
  hasError: PropTypes.bool
};

export default PaymentAgeWarning;
